import { FC } from 'react';
import { IconButton } from '../iconButton';
import { MAIN_COLOR } from 'shared/consts';
import exitIcon from 'assets/icons/exit-icon.svg';
import exitWhiteIcon from 'assets/icons/exit-white-icon.svg';
import { IconButtonStyles } from '../iconButton/iconButton';

interface ExitIconButtonProps {
	onClick: (...args: any[]) => void;
	backgroundMain?: boolean;
	hide?: boolean;
	light?: boolean;
	disableTouch?: boolean;
  styles: IconButtonStyles;
}

export const ExitIconButton: FC<ExitIconButtonProps> = ({
	onClick,
	backgroundMain = false,
	light = false,
	hide = false,
	disableTouch = false,
  styles,
}) => {
	return (
		<IconButton
			role="exit-button"
			iconSrc={light ? exitWhiteIcon : exitIcon}
			hide={hide}
			onClick={onClick}
			disableTouch={disableTouch}
			styles={styles || {
        background: backgroundMain ? MAIN_COLOR : 'transparent',
      }}
		/>
	);
};
